// extracted by mini-css-extract-plugin
export default {"ingredientsButton":"DMTP1"};